// store/Actions/AdminChatActions.js

import {
    SET_CONVERSATIONS,
    UPDATE_CONVERSATION_LATEST,
    SET_CONVERSATIONS_LOADING,
    SET_CONVERSATIONS_ERROR,
    SET_ACTIVE_CONVERSATION_USER,
    SET_MESSAGES,
    ADD_MESSAGE,
    SET_MESSAGES_LOADING,
    SET_MESSAGES_ERROR,
    SET_SENDING_MESSAGE,
    SET_SENDING_MESSAGE_ERROR,
  } from '../Types/AdminChatTypes';
  
  // --- Conversation List Actions ---
  
  export const setConversationsLoading = (isLoading) => ({
    type: SET_CONVERSATIONS_LOADING,
    payload: isLoading,
  });
  
  export const setConversationsAction = (conversations) => ({
    type: SET_CONVERSATIONS,
    payload: conversations,
  });
  
  export const setConversationsError = (error) => ({
    type: SET_CONVERSATIONS_ERROR,
    payload: error,
  });
  
  // This is called by the socket listener when a new message from any user arrives
  export const updateConversationLatestMessageAction = (payload) => ({
    type: UPDATE_CONVERSATION_LATEST,
    payload // Payload is now { message, activeUserId }
});
  
  
  // --- Active Chat Window Actions ---
  
  export const setActiveConversationUser = (userId) => ({
      type: SET_ACTIVE_CONVERSATION_USER,
      payload: userId
  });
  
  export const setMessagesLoading = (isLoading) => ({
      type: SET_MESSAGES_LOADING,
      payload: isLoading
  });
  
  export const setMessagesAction = (messages) => ({
    type: SET_MESSAGES,
    payload: messages,
  });
  
  export const setMessagesError = (error) => ({
      type: SET_MESSAGES_ERROR,
      payload: error
  });
  
  // This is called by listeners AND when the admin successfully sends a message
  export const addMessageToAction = (message) => ({
    type: ADD_MESSAGE,
    payload: message,
  });
  
  
  // --- Message Sending UI Actions ---
  
  export const setSendingMessage = (isSending) => ({
      type: SET_SENDING_MESSAGE,
      payload: isSending
  });
  
  export const setSendingMessageError = (error) => ({
      type: SET_SENDING_MESSAGE_ERROR,
      payload: error
  });